import React, {useState, useEffect} from 'react';
import styles from './BackgroundMedia.module.css';

const BackgroundMedia = ({ geoposition, customStyle }) => {
    const showVideo = false;
    const [isVideoLoaded, setIsVideoLoaded] = useState(false);
    const [videoSrc, setVideoSrc] = useState('');
    const [bgSrc, setBgSrc] = useState('');

    // Move media imports outside of component to prevent re-creation on each render
    const mediaAssets = {
        video: {
            tax: require("../../assets/video/tax-optimized.mp4"),
        },
        background: {
            tax: require("../../assets/tax.webp"),
        }
    };

    useEffect(() => {
        // Reset video loaded state when sources change
        setIsVideoLoaded(false);

        if (!geoposition?.state) {
            // Set default media
            setBgSrc(mediaAssets.background.tax);
            if(showVideo) {
                setVideoSrc(mediaAssets.video.tax);
            }
            return;
        }

        // Create a function to update media sources
        const updateMediaSources = () => {
            setBgSrc(mediaAssets.background.tax);
            setVideoSrc(mediaAssets.video.tax);
        };

        updateMediaSources();
    }, []); // Only depend on the specific properties we use

    // Force video element recreation when source changes
    const videoKey = `video-${videoSrc}`;

    return (
        <>
            <div
                className={styles.backgroundImage}
                style={{ backgroundImage: `` }}
            />
            <div className={styles.absBackground} style={customStyle}/>
            <div className={styles.videoContainer}>
                {videoSrc && (
                    <video
                        key={videoKey}
                        autoPlay
                        muted
                        loop
                        playsInline
                        className={`${styles.backgroundVideo} ${isVideoLoaded ? styles.videoLoaded : ''}`}
                        onLoadedData={() => setIsVideoLoaded(true)}
                    >
                        <source src={videoSrc} type="video/mp4"/>
                    </video>
                )}
            </div>
        </>
    );
};

export default BackgroundMedia;
